import React, { Fragment, useEffect } from "react";
import CommonFrom from "../../../../Common/Components/Form";
import Loading from "../../../../Common/Components/Loading";
import { CreateClassManager } from "../Hooks/index";
function Create() {
  const { formSubmit, loading } = CreateClassManager();

  return (
    <Fragment>
      {loading ? (
        <Loading count={1} col={12} height={300} />
      ) : (
        <CommonFrom
          form={form}
          header=" ایجاد برگزار کننده"
          btnName="ثبت  "
          submit={formSubmit}
          textbtn="لیست برگزار کننده ها"
          linkbtn="/Admin/ClassManger/List"
        />
      )}
    </Fragment>
  );
}

export default Create;
export const form = [
  {
    label: "نام برگزار کننده",
    size: "col-md-6",
    classNames: "mt-2",

    name: "fullname",
    type: "text",
  },
  {
    label: "کد ملی",
    size: "col-md-6",
    classNames: "mt-2",

    name: "national_code",
    type: "text",
  },
  {
    label: "شماره موبایل",
    size: "col-md-6",
    classNames: "mt-2",

    name: "mobile",
    type: "text",
  },
  {
    label: "ایمیل",
    size: "col-md-6",
    classNames: "mt-2",

    name: "email",
    type: "text",
  },
  {
    label: "جنسیت",
    size: "col-md-6",
    classNames: "mt-2",

    name: "gender",
    input: "select",
    options: [
      { id: "", name: "انتخاب کنید" },
      { id: "man", name: "مرد" },
      { id: "woman", name: "زن" },
    ],
  },
  {
    label: "تصویر برگزار کننده ",
    size: "col-md-12",
    classNames: "mt-2",

    name: "profile",
    input: "file",
    accept: "image/png, image/jpeg",
  },
];
